import * as React from "react";
import {
    Edit,
    SimpleForm,
    TextInput,
    List,
    Datagrid,
    TextField,
    DateField,
    Create,
    BooleanInput,
    BooleanField,
    ReferenceInput,
    SelectInput,
} from 'react-admin';

const ProductionCalendarsTitle = props => {
    return <span>{props.record ? `${props.record.name}` : ''}</span>;
};

export const ProductionCalendarsList = props => (
    <List {...props}>
        <Datagrid rowClick="edit">
            <TextField source="name" />
            <TextField source="unit_id" label="Unit" />
            <BooleanField source="is_active" label="Active" />
            <DateField source="created_at" />
        </Datagrid>
    </List>
);

export const ProductionCalendarsEdit = props => (
    <Edit {...props} title={<ProductionCalendarsTitle />} undoable={false}>
        <SimpleForm redirect="list">
            <TextInput source="name" />
            <ReferenceInput source="unit_id" reference="shoot-units" label="Unit" allowEmpty>
                <SelectInput optionText="name" />
            </ReferenceInput>
            <BooleanInput source="is_active" label="Active" />
        </SimpleForm>
    </Edit>
);

export const ProductionCalendarsCreate = props => (
    <Create {...props} title={<ProductionCalendarsTitle />} undoable={false} redirect="list">
        <SimpleForm redirect="list">
            <TextInput source="name" />
            <ReferenceInput source="unit_id" reference="shoot-units" label="Unit" allowEmpty>
                <SelectInput optionText="name" />
            </ReferenceInput>
            <BooleanInput source="is_active" label="Active" />
        </SimpleForm>
    </Create>
);